// extracted by mini-css-extract-plugin
module.exports = {"address":"Address_address__3A-x6","forms":"Address_forms__3yCum","inputs":"Address_inputs__1h2SW","btns":"Address_btns__2f-vw"};